export default __webpack_public_path__ + "009bcdd96e7dab7aebf24faa5fe23919.png";